/* Top level history page. This page should get all titles from MongoDB and show them. Upon
   clicking on a title, a component should then show that entry. That component should be
   re-used on any page where a history entry needs to be shown. */

import React, { useEffect, useState }  from 'react'
import axios                           from 'axios'
import Box                             from "@material-ui/core/Box"
import Paper                           from "@material-ui/core/Paper"

import HistoryTitles                   from '../Components/HistoryTitles'
import HistoryUpdateComponent          from '../Components/HistoryUpdateComponent'

import { CLIENT_PUBLIC_TOKEN }         from '../config'
import { node_server }                 from '../Helpers'

const HistoryUpdatePage = () => {

   const [ entries,                    setEntries                       ]  =  useState([])
   const [ entry,                      setEntry                         ]  =  useState({})
   const [ index,                      setIndex                         ]  =  useState(-1)
   const [ showHistoryUpdateComponent, setShowHistoryUpdateComponent    ]  =  useState(false)

   const handleClick = (id, i) => {
      console.log('You clicked on index number', i)
      console.log('You clicked on entry', entries[i])
      setIndex(i)
      setEntry(entries[i])
      setShowHistoryUpdateComponent(true)
   }

   const handleShow = () => {
      setShowHistoryUpdateComponent(false)
   }

   useEffect( () => {
      console.log('HistoryUpdatePage useEffect is running')
      console.log('HistoryUpdatePage entry')
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      axios.get(node_server + 'history/')
         .then( res => res.data )
         .then( data => {
            setEntries(data)
            // console.log('HistoryUpdatePage data[6] is', data[6])
            // setEntry(data[6])
         })
         .catch( (error) => {
            console.error(error)
         })
   }, [])

   return (
      <Box>
         {showHistoryUpdateComponent
            ?
               <HistoryUpdateComponent entry={entries[index]} handleShow={handleShow} />
            :
               <Paper style={{ marginTop: '50px', margin: '20px', backgroundColor: 'rgba(0, 0, 255, 0.05)' }} >
                  <HistoryTitles handleClick={handleClick} />
               </Paper>
         }
      </Box>
   )
}

export default HistoryUpdatePage
